<!-- DEV NOTE: please review the tooptip logic -->
<template>
	<span
		:class="['tooltip', ...stateClassList]"
		v-show="visibleActive"
		ref="tooltip"
		data-testid="tooltip-test"
		@click="tooltipDocumentClick"
		@mouseenter="onMouseEnter"
		@mouseleave="onMouseLeave"
	>
		<i
			v-if="state"
			:class="[
				'icon',
				state === 'negative' && 'icon-warning',
				state === 'warning' && 'icon-warning-01',
				state === 'positive' && 'icon-circle-check'
			]"
		/>
		<slot>Tooltip Content</slot>
		<PopperPosition
			:trackedRefName="trackedRef"
			:popoverRefName="$refs.tooltip"
			:placement="placement"
			:popperVisible="visibleActive"
			:trackerWatch="trackedRefName"
			:strategy="positionStrategy"
			:modifiers="popperModifiers"
		/>
	</span>
</template>

<script>
import componentStateMixin from '@/mixins/component-state-mixin';
import componentDocumentClickedMixin from '@/mixins/component-document-clicked-mixin';
import componentPositionMixin from '@/mixins/component-position-mixin';
import PopperPosition from '@/components/visual/popper-position/popper-position.vue';
import visibleDelayMixin from '@/mixins/visible-delay-mixin';

export default {
	name: 'Tooltip',
	components: {
		PopperPosition
	},
	mixins: [
		componentDocumentClickedMixin,
		componentStateMixin,
		componentPositionMixin,
		visibleDelayMixin
	],
	created() {
		this.documentClickedHandler = this.tooltipDocumentClick;
	},
	methods: {
		tooltipDocumentClick() {
			this.$emit('tooltipDocumentClick');
		},
		onMouseEnter(e) {
			this.$emit('mouseenter', e);
		},
		onMouseLeave(e) {
			this.$emit('mouseleave', e);
		}
	}
};
</script>

<style lang="scss" scoped>
.tooltip {
	display: inline-flex;
	padding: $padding-sm $padding-md;
	font-size: $txt-supporting-font-size;
	font-weight: $regular-font-weight;
	text-transform: initial;
	border-radius: $border-radius;
	background: var(--tooltip-bg);
	color: var(--tooltip-fg);
	z-index: $z-level4;
	max-width: 250px;
	text-align: left;
	> .icon {
		height: 14px; // for centering in the first row(12 px) and have space top and bottom.
		display: inline-flex;
		align-items: center;
		margin-right: $gutter-sm;
	}
}

/*------------------------------------*\
  #STATE-TYPE-STYLES
  This section is only for tooltip CSS change via state type.
  Neutral state is the default, CSS for that is located in the base component styles section.
  These classes are added/removed as needed via dev logic
\*------------------------------------*/

.tooltip {
	&.is-negative {
		border: solid 2px var(--ui-negative);
		background: var(--ui-negative-light);
		color: $ui-fg-dark;
	}

	&.is-positive {
		border: solid 2px var(--ui-positive);
		background: var(--ui-positive-light);
		color: $ui-fg-dark;
	}

	&.is-warning {
		border: solid 2px var(--ui-warning);
		background: var(--ui-warning-light);
		color: $ui-fg-dark;
	}
}
</style>
